import React from 'react';
import { useAuth } from './hooks/useAuth';
import LandingPage from './components/LandingPage';
import LoadingSpinner from './components/LoadingSpinner';
import UserHeader from './components/UserHeader';
import OpenAPIToMCPConverter from './openapi-to-mcp-converter';

function App() {
  const { user, loading, login, logout, isAuthenticated } = useAuth();

  // Show loading spinner during authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // Show landing page if user is not authenticated
  if (!isAuthenticated) {
    return <LandingPage onLogin={login} />;
  }

  // Show main app with user header if authenticated
  return (
    <div className="min-h-screen bg-gradient-to-br from-hpe-dark-bg via-hpe-dark-surface to-hpe-dark-bg text-white">
      <UserHeader user={user!} onLogout={logout} />
      <OpenAPIToMCPConverter />
    </div>
  );
}

export default App;